define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml",
	"SiteAdmin/DataSheetForm",
	"dojo/_base/lang",
	"csi/config"
], function(declare,AggregateFrom,xml,DataSheetForm,lang,config) {

	return declare(AggregateFrom, {

		isAggregate : true,

		_getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
			// summary: add special controller for size chart copy form
			var defView = this.inherited(arguments);
			if (!bCheckOnly && defView) {
				defView.classController = DataSheetForm;
			}

			return defView;
		},

		/**
		 * add hook to select and grey out SizeCharts that already have Shape Size Chart linked to this Style
		 * do nothing if subtype allows for multiple linked sc
		 * @override
		 */
		getFormData() {
			const fd = this.inherited(arguments);
			fd.m_bOmitSelections = true;
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		/**
		 * determine if Shape SC already has been linked in this Style's SizeCharts and if subtype allows multiple linked SC per shape SC
		 */
		_isPreSelected(ctx, fd) {
			for (const styleSC of ctx.getNode().StyleSizeCharts) {
				if (this.getParent().DataSheets.includes(styleSC) && !config.getSubtypeSetting(ctx.getNode().Subtype, "AllowMultipleLinkedSCperShapeSC")) {
					return true;
				}
			}
			return false;
		},
	
		/**
		 * @override
		 * set the size chart name
		 */
		onCreatePopupForm: function (view, node) {
			view.addDefaultValue(xml.ATTR_NAME, node.$Name);
			this.inherited(arguments);
		}
	});
});
